import {Form, formsStore} from '../../../stores/Form';
import {KeyboardEvent as ReactKeyboardEvent} from 'react';
import {eventPrevented} from '../../../utils/eventPrevented';

export const formF12handler = async (
    e: KeyboardEvent | ReactKeyboardEvent<HTMLElement>,
    currentForm: Form
) => {
    // Go to subform
    eventPrevented(e, true);
    const firstSubForm = currentForm.subFormsList?.[0];
    const subFormName = currentForm.activeSubForm?.ename || firstSubForm?.Ename;
    const isHTMLForm = currentForm.activeSubForm
        ? currentForm.activeSubForm.form?.Ishtml
        : firstSubForm?.IsText;

    const currentScreen = formsStore.currentScreen;
    const runInSearchMode = e.ctrlKey;

    if (subFormName) {
        await currentScreen.runSubForm(subFormName, currentForm, isHTMLForm, runInSearchMode);
    }
};
